import { render, staticRenderFns } from "./SalonSelection.vue?vue&type=template&id=4c2b6f28&"
import script from "./SalonSelection.vue?vue&type=script&lang=js&"
export * from "./SalonSelection.vue?vue&type=script&lang=js&"
import style0 from "./SalonSelection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports